import { createSlice } from "@reduxjs/toolkit";

const navSlice = createSlice({
  name: "nav",
  initialState: {
    nav: [],
  },
  reducers: {
    setNav: (state, action) => {
      state.nav = action.payload;
    },
  },
});

export const { setNav } = navSlice.actions;
export default navSlice.reducer;
